// React state updates are batched; acquire synchronously before any async work.
export function createSubmissionGate() {
  let pending = false;
  return {
    get pending() { return pending; },
    begin() {
      if (pending) return false;
      pending = true;
      return true;
    },
    end() { pending = false; },
  };
}
